import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Check, Close } from "@mui/icons-material";
import axios from "axios";
import "./CheckingTools.css";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import key from "../../assets/svg/wrench (1) 1.svg";

const CheckingTools = () => {
  const navigate = useNavigate();
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const GET_ITEMS_URL = "https://estbn.com/EstbnNew/public/api/stuff/get-vehicle-equipments";
  const SAVE_CHECK_URL =
    "https://estbn.com/EstbnNew/public/api/stuff/store-equipments-check";

  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const response = await axios.get(GET_ITEMS_URL, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          const items = response.data.data.data;
          console.log(response.data.data.data);
          setTools(
            items.map((item) => ({
              id: item.id,
              name: item.name_ar,
              status: 1,
              hasNote: false,
            }))
          );
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchTools();
  }, [token]);

  const handleStatusChange = (id, newStatus) => {
    setTools(
      tools.map((tool) =>
        tool.id === id ? { ...tool, status: newStatus } : tool
      )
    );
  };

  const handleSave = async () => {
    if (!token) return alert("يرجى تسجيل الدخول");

    setSaving(true);
    try {
      // تجهيز البيانات كـ JSON بدلاً من FormData لتجنب مشاكل المصفوفات في PHP
      const payload = {
        doorstep_vehicle_id: 204, // هذا الرقم الظاهر في صفحتك، تأكد إذا كان يجب أن يكون ديناميكياً
        items: tools.map((tool) => ({
          vehicle_item_id: tool.id,
          status: tool.status,
        })),
      };

      const response = await axios.post(SAVE_CHECK_URL, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // تغيير النوع لـ JSON
          Accept: "application/json",
        },
      });

      if (response.data.success) {
        alert("تم حفظ الفحص بنجاح");
        navigate(-1);
      }
    } catch (error) {
      // إظهار رسالة الخطأ القادمة من السيرفر في التنبيه للمساعدة في الحل
      const errorMsg = error.response?.data?.message || "حدث خطأ غير متوقع";
      console.error("Save Error Response:", error.response?.data);
      alert(`فشل الحفظ: ${errorMsg}`);
    } finally {
      setSaving(false);
    }
  };

  const totalTools = tools.length;
  const healthyCount = tools.filter((t) => t.status === 1).length;
  const brokenCount = tools.filter((t) => t.status === 0).length;

  if (loading) return <div className="text-center mt-5">جاري التحميل...</div>;

  return (
    <div className="ct-main-wrapper py-4 px-3 px-md-5" dir="rtl">
      <div className="ct-header-card p-4 mb-4 d-flex justify-content-between align-items-center">
        <div className="text-end">
          <h5 className="fw-bold mb-2">مراجعة الادوات علي سيارة #204</h5>
          <p className="text-muted small mb-0 lh-base">
            راجع حالة الأدوات التي أقر بها الفني وتأكد من سلامتها.
          </p>
        </div>
        <div className="text-center">
          <img src={key} alt="key" width="60" />
          <div
            className="small fw-bold cursor-pointer"
            onClick={() => navigate(-1)}
          >
            مراجعة الادوات <ChevronLeft fontSize="small" />
          </div>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-lg-7 order-lg-2">
          <div className="ct-info-card p-4">
            <div className="d-flex justify-content-end gap-5 mb-3 px-2">
              <span className="small fw-bold text-muted">سليم</span>
              <span className="small fw-bold text-muted">عطل</span>
            </div>
            <div className="ct-tools-list">
              {tools.map((tool) => (
                <div
                  key={tool.id}
                  className="ct-tool-item d-flex align-items-center justify-content-between py-3 border-bottom"
                >
                  <div className="d-flex align-items-center gap-3">
                    <img src={noteIcon} alt="note" width="24" />
                    <span className="fw-bold small">{tool.name}</span>
                  </div>
                  <div className="d-flex gap-5">
                    <div
                      className={`ct-check-box healthy ${
                        tool.status === 1 ? "active" : ""
                      }`}
                      onClick={() => handleStatusChange(tool.id, 1)}
                    >
                      <Check fontSize="inherit" />
                    </div>
                    <div
                      className={`ct-check-box broken ${
                        tool.status === 0 ? "active" : ""
                      }`}
                      onClick={() => handleStatusChange(tool.id, 0)}
                    >
                      <Close fontSize="inherit" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-lg-5 order-lg-1">
          <div className="ct-info-card p-4 h-100">
            <div className="d-flex justify-content-between align-items-start mb-4">
              <span className="text-muted small">
                تم فحص {totalTools} من {totalTools} اداة
              </span>
              <h5 className="fw-bold">ملخص الفحص</h5>
            </div>
            <div className="d-flex flex-column align-items-end gap-3">
              <div className="d-flex align-items-center gap-2">
                <span className="fw-bold">{healthyCount} سليم</span>
                <div className="ct-summary-icon healthy">
                  <Check fontSize="inherit" />
                </div>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span className="fw-bold">{brokenCount} به عطل</span>
                <div className="ct-summary-icon broken">
                  <Close fontSize="inherit" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <button
          className="btn btn-dark ct-save-btn px-5 py-2"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "جاري الحفظ..." : "حفظ الفحص"}
        </button>
      </div>
    </div>
  );
};

export default CheckingTools;
